import React, { useEffect } from "react";
import "../../../assets/css/patient/Privacy.css";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
import Footer from "../../../components/general/footer/Footer";

// Har section yahan ek object hai — naya section add karna ho to bas array mein add karo
const sections = [
  {
    title: "Information We Collect",
    body: "We collect information you provide directly, such as your name, email, phone number, and messages you exchange with our AI assistant or therapists during speech therapy sessions.",
  },
  {
    title: "How We Use Your Information",
    body: "Your information is used to create and manage your account, personalize AI-guided speech therapy recommendations, connect you with the right therapist, and improve our platform over time.",
  },
  {
    title: "AI Processing & Third Parties",
    body: "Messages you send to our AI assistant are processed through a third-party AI provider to generate responses. We do not sell your personal data to advertisers or unrelated third parties.",
  },
  {
    title: "Data Shared with Therapists",
    body: "If you are matched with a therapist, relevant session information and progress notes may be shared with that therapist to support your care. Therapists are bound to keep this information confidential.",
  },
  {
    title: "Data Storage & Security",
    body: "Your data is stored in a secured database with access restricted to authorized systems and personnel. We take reasonable measures to protect your information from unauthorized access.",
  },
  {
    title: "Your Rights",
    body: "You may request to access, update, or delete your personal data at any time by contacting us. You may also close your account, after which your data will be removed in line with applicable law.",
  },
];

function Privacy() {
  // Page khulte hi scroll top pe le jao — jaisa Home/About/Blog mein hota hai
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <MyNavbar />

      <section className="privacy">
        <div className="privacy-header">
          <span className="privacy-eyebrow">Legal</span>
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: August 2026</p>
          <p className="privacy-intro">
            Your privacy matters to us. This policy explains what
            information we collect on SpeechTherapy, how we use it, and the
            choices you have regarding your data.
          </p>
        </div>

        <div className="privacy-body">
          {sections.map((section, index) => (
            <div className="privacy-section" key={section.title}>
              <span className="section-number">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div>
                <h2>{section.title}</h2>
                <p>{section.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Privacy;